export const OPEN_CHATBOT_EVENT = "gp:open-chatbot";

export const openChatbot = () => {
    window.dispatchEvent(new Event(OPEN_CHATBOT_EVENT));
};
